import { useEffect, useMemo } from 'react';

import { ScreenReadersContent } from '@hivebrite/design-system/ScreenReadersContent';

import { getScreenReaderStatus } from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/utils';

import TopicEmptyCard from './TopicEmptyCard';
import Topics from './Topics';
import { GRID } from '../constants/displayAs';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import useTopicsFilteredTopics from '../hooks/useTopicsFilteredTopics';

const TopicsFilteredTopics = () => {
  const {
    name,
    topics,
    totalTopics,
    isFetchingTopics,
    params,
    loadNextPage,
    handleFetchTopics,
    updateTopicApproval,
  } = useTopicsFilteredTopics();
  const { setHandleFetchFilteredTopics } = useTopicsIndexContext();

  useEffect(() => {
    if (handleFetchTopics && setHandleFetchFilteredTopics) {
      setHandleFetchFilteredTopics(() => handleFetchTopics);
    }
  }, [handleFetchTopics, setHandleFetchFilteredTopics]);

  const screenReaderStatus = useMemo(
    () =>
      getScreenReaderStatus({
        isFetching: isFetchingTopics,
        itemsSize: totalTopics,
        hasNoResult: !isFetchingTopics && totalTopics === 0,
      }),
    [isFetchingTopics, totalTopics],
  );

  return (
    <>
      <ScreenReadersContent aria-live="polite" role="status">
        {screenReaderStatus}
      </ScreenReadersContent>
      {totalTopics === 0 && !isFetchingTopics ? (
        <TopicEmptyCard />
      ) : (
        <Topics
          dataTestId="topics-filtered-topics"
          name={name}
          topics={topics}
          totalTopics={totalTopics}
          isFetchingTopics={isFetchingTopics}
          displayAs={GRID}
          loadNextPage={loadNextPage}
          params={params}
          updateTopicApproval={updateTopicApproval}
        />
      )}
    </>
  );
};

export default TopicsFilteredTopics;
